import React, { useEffect, useState, useCallback, Fragment } from 'react';
import { Card, Container, Input } from 'reactstrap';

import { cheAdminSettingsService } from 'services';
import { Toggle } from './components';
import { Button } from '../blocks';
import { onChangeFunction } from '../../shared';

export const AdminSettings = () => {
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [userInput, setUserInput] = useState([]);
    const fetchOptions = async () => {
        try {
            const res = await cheAdminSettingsService.getAdminSettings();
            if (res) setUserInput(res);
        } catch (error) {
            console.error(error);
        }
    };
    const onSubmit = useCallback(async () => {
        setLoading(true);
        try {
            const res = await cheAdminSettingsService.postAdminSettings(userInput);
            if (res) setUserInput(res);
            window.location.reload();
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    }, [userInput]);
    useEffect(() => {
        fetchOptions();
    }, []);

    const handleChange = event => {
        const { name, value } = event.target;

        setUserInput(prevState =>
            prevState.map(item => (item.name === name ? { ...item, value: value } : item))
        );
    };
    return (
        <Container fluid>
            <Card className="p-3">
                <div className="mb-4 d-sm-flex text-center text-sm-left align-items-center justify-content-between">
                    <h3 className="mb-3 mb-sm-0">Admin Settings</h3>
                    <Button
                        color="success"
                        className="btn-shadow px-4"
                        onClick={onSubmit}
                        loading={loading}
                    >
                        Save Changes
                    </Button>
                </div>
                <label>Program Request Email Manager</label>
                <Input
                    type="text"
                    placeholder="Program Request Email Manager"
                    onChange={handleChange}
                    name="programRequestEmail"
                    value={
                        userInput.find(item => item.name === 'programRequestEmail')
                            ?.value || ''
                    }
                />
            </Card>
        </Container>
    );
};
